import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var TourIcon = (props, _ref) => {
  var {
    attrs
  } = _ref;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var {
    width,
    height,
    strokeColor,
    fillColor
  } = props;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.3 17.565",
    width: "".concat(width),
    height: "".concat(height),
    class: (_a = props.class) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, [h("path", {
    fill: fillColor,
    stroke: (_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : strokeColor,
    "stroke-linecap": "".concat((_d = attrs["stroke-linecap"]) !== null && _d !== void 0 ? _d : "round"),
    "stroke-linejoin": "".concat((_e = attrs["stroke-linejoin"]) !== null && _e !== void 0 ? _e : "round"),
    "stroke-width": "".concat((_f = attrs["stroke-width"]) !== null && _f !== void 0 ? _f : "1"),
    d: "M16.466 2.582c4.678.992 8.034 3.687 8.034 6.857 0 4.011-5.373 7.265-12 7.265S.5 13.45.5 9.439c0-3.17 3.355-5.865 8.034-6.857"
  }), h("path", {
    fill: "#101d31",
    d: "M15.828 9.467a3.111 3.111 0 1 1-3.111-3.111 3.111 3.111 0 0 1 3.111 3.111"
  }), h("path", {
    fill: "none",
    stroke: (_g = attrs["stroke-color"]) !== null && _g !== void 0 ? _g : strokeColor,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "".concat((_h = attrs["stroke-width"]) !== null && _h !== void 0 ? _h : "1"),
    d: "M15.828 9.467a3.111 3.111 0 1 1-3.111-3.111 3.111 3.111 0 0 1 3.111 3.111"
  }), h("path", {
    fill: "none",
    stroke: (_j = attrs["stroke-color"]) !== null && _j !== void 0 ? _j : strokeColor,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "".concat((_k = attrs["stroke-width"]) !== null && _k !== void 0 ? _k : "1"),
    d: "m18.762.915-2.255 1.853v.013l1.486 2.81"
  })]);
};